import React, { useState, useEffect, useCallback, memo } from "react";
import MemberTips from "../../MemberTips";
import { useTranslation } from "react-i18next";
import "./index.scss";
import { base64Unsuccesspng } from "@/components/Success/images/unSuccess";
// import errorIconSvg from "/public/login/images/errorIconSvg.svg";
import successIcon from "@/components/Success/images/icon_01.png";

const ToastItem = ({
    state = "error",
    message = "successful",
    showTime,
    id,
    onExit,
}) => {
    const [show, setShow] = useState(true);
    const { t } = useTranslation();

    useEffect(() => {
        let ref;
        if (showTime) {
            ref = setTimeout(() => {
                setShow(false);
            }, showTime);
        }
        return () => {
            clearTimeout(ref);
        };
    }, [id]);

    useEffect(() => {
        if (show === false) {
            onExit(id);
        }
    }, [show, onExit]);

    return show ? (
        <div
            className={`toastResultMeassage successful ${state}`}
            style={{ "--showTime": `${showTime / 1000}s` }}
            key={id}
        >
            {state === "error" && (
                <>
                    <MemberTips iconSrc={base64Unsuccesspng} stateType="error">
                        <div className="tip-text">{message}</div>
                    </MemberTips>
                </>
            )}
            {state === "success" && (
                <>
                    <MemberTips
                        iconSrc={successIcon}
                        className="success"
                        stateType="success"
                    >
                        <div className="tip-text">{message}</div>
                    </MemberTips>
                </>
            )}
        </div>
    ) : null;
};

const MemoToastItem = memo(ToastItem);

const Toast = () => {};

export default Toast;

const useMobileToast = ({ style = {}, max = 3, showTime = 5000 } = {}) => {
    const [toastItem, setToastItem] = useState([]);
    const [curMsg, setCurMsg] = useState("");
    const [hasCallBackFn, setHasCallBackFn] = useState();
    const isApp = window?.MBSSClient;

    const onExit = useCallback(
        (key) => {
            setToastItem([
                ...toastItem.filter((i) => {
                    return String(i.key) != key;
                }),
            ]);
            setCurMsg("");
            hasCallBackFn?.();
        },
        [toastItem]
    );

    const toastApi = useCallback(
        ({ state = "error", message = "successful", cbFunc }) => {
            const memberAppBtn = document.querySelector(
                ".MobileMemberButtonBox-app-button"
            );
            // if (memberAppBtn) {
            //     const btnHeight = memberAppBtn.offsetHeight;
            //     const toastDom = document.querySelector('.mobileToast');
            //     toastDom.style.bottom = `${btnHeight + 12}px`
            // }
            setHasCallBackFn(cbFunc);
            if (toastItem.length < max) {
                let key = new Date().getTime();
                setToastItem([
                    {
                        showTime,
                        state,
                        message,
                        key,
                        id: key,
                    },
                ]);
                setCurMsg(message);
            } else if (toastItem.length > 0 && curMsg != message) {
                let key = new Date().getTime();
                setToastItem([
                    {
                        showTime,
                        state,
                        message,
                        key,
                        id: key,
                    },
                ]);
                setCurMsg(message);
            }
        },
        [toastItem]
    );

    return [
        toastApi,
        <div
            className={`mobileToast ${isApp ? "isApp" : "webSite"}`}
            style={{ ...style }}
        >
            {toastItem.map((item) => (
                <MemoToastItem {...item} onExit={onExit} />
            ))}
        </div>,
    ];
};

Toast.useMobileToast = useMobileToast;

export { Toast };
